
export enum MessageType {
    Success = 'toast-success',
    Warning = 'toast-warning',
    Error = 'toast-error',
    Info = 'toast-info'
}